import { render, staticRenderFns } from "./TargetingDetails.vue?vue&type=template&id=a06aba44&"
import script from "./TargetingDetails.vue?vue&type=script&lang=js&"
export * from "./TargetingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports